import { LucideIcon } from "lucide-react";

interface ServiceCardProps {
    title: string;
    description: string;
    icon: LucideIcon;
    iconSize?: number;
    iconBgColor?: string;
    iconColor?: string;
}

export default function ServiceCard({ 
    title, 
    description, 
    icon: Icon,
    iconBgColor = "bg-gradient-to-r from-purple-600 to-blue-600",
    iconColor = "text-white"
}: ServiceCardProps) {
    return (
        <div className="group h-full">
            <div className="h-full rounded-2xl bg-gradient-to-br from-purple-600/5 to-blue-600/5 border border-purple-500/20 p-6 md:p-8 hover:border-purple-500/50 hover:bg-gradient-to-br hover:from-purple-600/10 hover:to-blue-600/10 transition-all duration-300">
                <div className="mb-6">
                    <div className={`w-14 h-14 rounded-xl ${iconBgColor} flex items-center justify-center ${iconColor} group-hover:scale-110 transition-all duration-300`}>
                        <Icon className="w-7 h-7" strokeWidth={2} />
                    </div>
                </div>

                <h3 className="text-xl font-bold text-white mb-4">
                    {title}
                </h3>

                <p className="text-gray-300 text-base leading-relaxed">
                    {description}
                </p>
            </div>
        </div>
    );
}